import React from 'react'
import Grid from '@mui/material/Grid'
import PrimaryAttentionGrab from 'components/landing-page/PrimaryAttentionGrab'
import CardAttentionGrabSection from 'components/landing-page/CardAttentionGrabSection'
import { highlightCards, keyFeaturesCards } from 'components/landing-page/AttentionCardsData'

const Page = () => (
  <Grid item>
    <Grid container item direction="column" alignItems="center" alignSelf="center" spacing={2}>
      <PrimaryAttentionGrab />
    </Grid>

    <Grid item>
      <CardAttentionGrabSection cards={highlightCards} title="Reimagine Your Scrap Software Experience" />
    </Grid>

    <Grid item>
      <CardAttentionGrabSection cards={keyFeaturesCards} title="Key Features" />
    </Grid>
  </Grid>
)

export default Page
